import { IAction, isFailedAction } from '@/redux/actions/action-helpers'
import { ModalErrorTypes } from '@/redux/actions/actions.types'
import { ApplicationState } from '@/redux/stores/types'
import { ApiError, isModalError } from '@/types/error/ErrorResponse'

type ModalErrorState = ApplicationState['modalError']

export function modalErrorReducer(state: ModalErrorState = null, action: IAction): ModalErrorState {
	if (isFailedAction<ApiError>(action) && action.payload && isModalError(action.payload)) {
		return action.payload.modal
	}

	if (action.type === ModalErrorTypes.Clean.SUCCESS) {
		return null
	}

	return state
}
